import { Shield } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * 투자 정보 면책조항 — 전역 공통 컴포넌트.
 * - compact: 페이지 하단/푸터용 한 줄 요약
 * - full:    종목 상세/세력분석/면책조항 페이지용 상세 문구
 */
type Variant = 'compact' | 'full';

interface Props {
  variant?: Variant;
  className?: string;
}

export function InvestmentDisclaimer({ variant = 'compact', className }: Props) {
  if (variant === 'compact') {
    return (
      <div
        className={cn(
          'flex items-start justify-center gap-1.5 border-t border-[var(--color-border)] px-4 py-2 text-center text-xs text-gray-400',
          className,
        )}
      >
        <Shield className="mt-0.5 h-3 w-3 shrink-0" />
        <p className="leading-relaxed">
          본 사이트는 투자 정보 공유 커뮤니티로, 금융투자업자가 아닙니다.
          모든 정보는 투자 참고용이며 투자 결과의 책임은 투자자 본인에게 있습니다.
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'rounded-lg border border-[var(--color-border)] bg-gray-50 p-4 text-sm leading-relaxed text-gray-500',
        className,
      )}
    >
      <div className="flex items-center gap-2 text-gray-600">
        <Shield className="h-4 w-4 shrink-0" />
        <strong className="font-semibold">【투자 위험 고지】</strong>
      </div>
      <p className="mt-2">
        시세공간은 투자 정보 공유 커뮤니티로, 금융위원회에 등록된 금융투자업자가 아닙니다.
      </p>
      <ul className="mt-3 space-y-1.5 pl-0">
        <li className="flex gap-2">
          <span aria-hidden className="shrink-0">•</span>
          <span>
            본 사이트의 모든 정보는 투자 참고용이며, 투자 권유 또는 투자 조언이 아닙니다.
          </span>
        </li>
        <li className="flex gap-2">
          <span aria-hidden className="shrink-0">•</span>
          <span>투자 결과에 대한 모든 책임은 투자자 본인에게 있습니다.</span>
        </li>
        <li className="flex gap-2">
          <span aria-hidden className="shrink-0">•</span>
          <span>
            원금 손실이 발생할 수 있으며, 손실 보전이나 이익 보장을 약속하지 않습니다.
          </span>
        </li>
        <li className="flex gap-2">
          <span aria-hidden className="shrink-0">•</span>
          <span>
            게시된 내용은 작성자 개인의 의견이며 시세공간의 공식 입장과 다를 수 있습니다.
          </span>
        </li>
      </ul>
    </div>
  );
}
